import validate from "/Users/david/clawd/localauthority/node_modules/.pnpm/nuxt@3.17.4_@libsql+client@0.15.5_@parcel+watcher@2.5.1_@types+node@22.15.29_better-sqlite3@1_kq2ohbwrs5kljyn4mydaobrkbu/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/david/clawd/localauthority/node_modules/.pnpm/nuxt@3.17.4_@libsql+client@0.15.5_@parcel+watcher@2.5.1_@types+node@22.15.29_better-sqlite3@1_kq2ohbwrs5kljyn4mydaobrkbu/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}